// Демо-данные окна «AI Prompts» для главной Hub.
// Промпт — правило, которое правит черновик ответа продавца: меняет тон, исправляет грамматику,
// переводит или упрощает текст. Встроенные промпты можно включать и выключать, свои — создавать и удалять.
import { t } from "@/lib/i18n";

export type AiPrompt = {
  id: string;
  title: string;
  description: string;
  icon: string;
  instruction: string;
  enabled: boolean;
  builtin: boolean;
};

export const aiPrompts: AiPrompt[] = [
  {
    id: "p-tone",
    title: t("Изменить тон"),
    description: t("Сделать ответ более профессиональным, дружелюбным, эмпатичным или прямым."),
    icon: "ri-emotion-line",
    instruction: t(
      "Перепиши ответ в нейтрально-профессиональном тоне: без сленга и лишних эмоций, но без канцелярита. Сохрани все факты, цены и сроки без изменений.",
    ),
    enabled: true,
    builtin: true,
  },
  {
    id: "p-translate",
    title: t("Перевод"),
    description: t("Перевести сообщение на выбранный язык клиента."),
    icon: "ri-translate-2",
    instruction: t("Переведи ответ на язык, на котором написал клиент. Не добавляй и не убирай факты, имена и суммы — переводи их дословно."),
    enabled: true,
    builtin: true,
  },
  {
    id: "p-grammar",
    title: t("Орфография и грамматика"),
    description: t("Автоматически исправить грамматику, орфографию и пунктуацию."),
    icon: "ri-check-double-line",
    instruction: t("Исправь орфографию, пунктуацию и опечатки в черновике. Не меняй смысл, порядок предложений и цифры."),
    enabled: true,
    builtin: true,
  },
  {
    id: "p-simplify",
    title: t("Упростить язык"),
    description: t("Сделать сообщение проще для чтения и понимания."),
    icon: "ri-text-wrap",
    instruction: t("Разбей длинные предложения на короткие, убери сложные обороты. Пиши так, чтобы понял человек без технического бэкграунда."),
    enabled: true,
    builtin: true,
  },
];

// иконки, из которых выбирают при создании своего промпта
export const promptIcons = [
  "ri-emotion-line",
  "ri-check-double-line",
  "ri-translate-2",
  "ri-text-wrap",
  "ri-magic-line",
  "ri-filter-3-line",
  "ri-list-check",
  "ri-quill-pen-line",
];

// типы промптов в окне создания: подставляют название и иконку
export const promptKinds = [
  { id: "tone", label: t("Тон"), icon: "ri-emotion-line", hint: t("Как звучит ответ: дружелюбно, строго, коротко") },
  { id: "grammar", label: t("Грамматика"), icon: "ri-check-double-line", hint: t("Орфография, пунктуация и опечатки") },
  { id: "translate", label: t("Перевод"), icon: "ri-translate-2", hint: t("Язык, на котором отвечаем клиенту") },
  { id: "format", label: t("Формат"), icon: "ri-text-wrap", hint: t("Длина, списки, структура ответа") },
  { id: "custom", label: t("Своё правило"), icon: "ri-magic-line", hint: t("Любая инструкция для ассистента") },
];

// черновик ответа в превью и его «перевод» для демонстрации перевода
export const sampleDraft = t(
  "Здраствуйте! Подскажыте пажалуста, сколько стоит тариф для 12 человек и можна ли оплатить по счёту???",
);

export const sampleDraftEn =
  "Hello! Could you please tell me how much the plan costs for 12 people, and can we pay by invoice?";

// что видно в подсказке под превью
export const promptsHint = t("AI Prompts правит только черновик ответа — продавец всегда видит результат и отправляет его сам.");
